<template>
  <div class="page-wrapper">
    <HeaderComponent />

    <div class="page-content">
      <AppBreadcrumb :items="[{ label: $t('medical.breadcrumb') }]" />

      <template v-if="medicalInfo.length">
        <div class="info-grid">
          <article
            class="info-card"
            v-for="(item, index) in medicalInfo"
            :key="item.id"
          >
            <div v-if="item.image" class="info-image-wrap">
              <img
                :src="item.image"
                :alt="item.title"
                class="info-image"
              />
            </div>

            <div class="info-card-body">
              <div class="info-card-top">
                <div class="info-number">{{ index + 1 }}</div>

                <div class="info-head">
                  <h3 class="info-title">{{ item.title }}</h3>
                </div>
              </div>

              <div class="info-divider"></div>

              <p class="info-text">
                {{ item.text }}
              </p>
            </div>
          </article>
        </div>
      </template>

      <template v-else>
        <div class="empty-wrap">
          <a-empty :description="$t('medical.empty')" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent.vue'
import AppBreadcrumb from '../components/AppBreadcrumb.vue'

export default {
  components: {
    HeaderComponent,
    AppBreadcrumb
  },
  computed: {
    medicalInfo() {
      return this.$store.getters.medicalInfo || []
    }
  }
}
</script>

<style scoped>
.info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.info-card {
  overflow: hidden;
  border-radius: 22px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.03);
  box-shadow: var(--shadow);
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.info-card:hover {
  transform: translateY(-2px);
  border-color: rgba(59, 130, 246, 0.24);
}

.info-image-wrap {
  width: 100%;
  height: 220px;
  overflow: hidden;
  border-bottom: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.02);
}

.info-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.35s ease;
}

.info-card:hover .info-image {
  transform: scale(1.03);
}

.info-card-body {
  padding: 18px;
}

.info-card-top {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.info-number {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(135deg, var(--primary), var(--primary-soft));
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.22);
}

.info-head {
  min-width: 0;
  flex: 1;
}

.info-title {
  margin: 4px 0 0;
  font-size: 18px;
  line-height: 1.35;
  font-weight: 800;
  color: var(--text);
}

.info-divider {
  height: 1px;
  background: var(--border);
  margin: 14px 0 12px;
}

.info-text {
  margin: 0;
  color: var(--text-soft);
  font-size: 14px;
  line-height: 1.8;
  white-space: pre-line;
  text-align: justify;
}

.empty-wrap {
  min-height: calc(100vh - 180px);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  border-radius: 20px;
}

:deep(.ant-empty) {
  margin: 0;
}

:deep(.ant-empty-description) {
  color: var(--text-soft) !important;
  font-size: 14px;
  font-weight: 500;
}

@media (max-width: 992px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .info-grid {
    gap: 14px;
  }

  .info-card {
    border-radius: 18px;
  }

  .info-image-wrap {
    height: 190px;
  }

  .info-card-body {
    padding: 16px;
  }

  .info-title {
    font-size: 16px;
  }

  .info-text {
    font-size: 13px;
    line-height: 1.7;
  }

  .empty-wrap {
    min-height: calc(100vh - 150px);
    padding: 16px;
  }
}
</style>